import axios from "axios";
import { Urls } from "../../../store/urls";

export const getSiteNavigationFiltersRepo = (data) => {
    return axios({
        method: "GET",
        url: Urls.GET_SITE_NAVIGATION_FITERS,
        params: data,
    });
};

export const getSiteNavigationRepo = (data) => {
    return axios({
        method: "GET",
        url: Urls.GET_SITE_NAVIGATION,
        params: data,
    });
};

export const getSiteNavigationEditRepo = (id,data) => {
    return axios({
        method: "GET",
        url: Urls.GET_SITE_NAVIGATION + "/" + id,
        params: data,
    });
};

export const getSiteNavigationItemsRepo = (data) => {
    return axios({
        method: "GET",
        url: Urls.GET_SITE_NAVIGATION_ITEMS,
        params: data,
    });
};

export const postSiteNavigationItemsRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_SITE_NAVIGATION_ITEMS,
        data: data,
    });
};

export const putSiteNavigationItemsRepo = (id,data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_SITE_NAVIGATION_ITEMS + "/" + id,
        data: data,
    });
};

export const deleteSiteNavigationItemsRepo = (data) => {
    return axios({
        method: "DELETE",
        url: Urls.GET_SITE_NAVIGATION_ITEMS,
        params: data,
    });
};